import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import CoreStyles from '../core/Styles';

export default class Panel extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            panel: {
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                overflow: "hidden",
                backgroundColor: CoreMetrics.Color.LightUI.SecondaryBG,
                paddingTop: CoreMetrics.Grid.VerticalMargin,
                paddingBottom: CoreMetrics.Grid.VerticalMargin,
                paddingLeft: CoreMetrics.Grid.HorizontalMargin,
                paddingRight: CoreMetrics.Grid.HorizontalMargin,
            },
        });

        let combinedStyles = [styles.panel, CoreStyles.hairlineOuterStroke];
        if (this.props.styles != null) {
            combinedStyles = combinedStyles.concat(this.props.styles);
        }

        return (
            <div className={css(combinedStyles)}>
                {this.props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Panel.jsx